import { Controller } from "@hotwired/stimulus"

// Submits the surrounding form when a control changes. Works whether the
// controller is attached to the form itself (this.element is the form) or to a
// field inside it (this.element.form is the form).
export default class extends Controller {
  submit() {
    const form = this.element.form ?? this.element
    if (form.requestSubmit) {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }
}
